import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaEnvelopeOpenText } from 'react-icons/fa';

const AdminCreateTextMessage = () => {
  const [content, setContent] = useState('');
  const [scheduledDate, setScheduledDate] = useState('');
  const [status, setStatus] = useState('scheduled');
  const [recurrence, setRecurrence] = useState('none');
  const [restaurantId, setRestaurantId] = useState('');
  const [restaurants, setRestaurants] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await axios.get('/api/admin/restaurants', {
          headers: { Authorization: `Bearer ${token}` },
        });
        // console.log(response);
        setRestaurants(response.data.restaurants);
      } catch (error) {
        console.error('Error fetching restaurants:', error);
      }
    };

    fetchRestaurants();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        '/api/admin/text-messages',
        {
          content,
          scheduledDate,
          status,
          recurrence,
          restaurant: restaurantId,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/admin/textMessages');
    } catch (error) {
      console.error('Error creating text message:', error);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8 max-w-[600px]'>
      <h1 className='text-3xl font-bold mb-6 flex items-center'>
        <FaEnvelopeOpenText className='mr-3' /> Create Text Message
      </h1>
      <form
        onSubmit={handleSubmit}
        className='bg-white p-6 shadow-lg rounded-lg'
      >
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Content
          </label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Scheduled Date
          </label>
          <input
            type='datetime-local'
            value={scheduledDate}
            onChange={(e) => setScheduledDate(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Status
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className='w-full p-3 border rounded'
          >
            <option value='scheduled'>Scheduled</option>
            <option value='sent'>Sent</option>
            <option value='failed'>Failed</option>
          </select>
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Recurrence
          </label>
          <select
            value={recurrence}
            onChange={(e) => setRecurrence(e.target.value)}
            className='w-full p-3 border rounded'
          >
            <option value='none'>None</option>
            <option value='daily'>Daily</option>
            <option value='weekly'>Weekly</option>
            <option value='monthly'>Monthly</option>
          </select>
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Restaurant
          </label>
          <select
            value={restaurantId}
            onChange={(e) => setRestaurantId(e.target.value)}
            className='w-full p-3 border rounded'
          >
            <option value=''>Select Restaurant</option>
            {restaurants?.map((restaurant) => (
              <option key={restaurant._id} value={restaurant._id}>
                {restaurant.name}
              </option>
            ))}
          </select>
        </div>
        <button
          type='submit'
          className='bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200'
        >
          Create Text Message
        </button>
      </form>
    </div>
  );
};

export default AdminCreateTextMessage;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { FaSave } from 'react-icons/fa';

// const AdminCreateTextMessage = () => {
//   const [restaurantId, setRestaurantId] = useState('');
//   const [content, setContent] = useState('');
//   const [scheduledDate, setScheduledDate] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [restaurants, setRestaurants] = useState([]);
//   const token = localStorage.getItem('adminToken');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchRestaurants = async () => {
//       try {
//         const response = await axios.get('/api/admin/restaurants', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setRestaurants(response.data);
//       } catch (error) {
//         console.error('Error fetching restaurants:', error);
//       }
//     };

//     fetchRestaurants();
//   }, [token]);

//   const handleCreate = async () => {
//     setLoading(true);
//     try {
//       await axios.post(
//         '/api/admin/text-messages',
//         { restaurant: restaurantId, content, scheduledDate },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       navigate('/admin/text-messages');
//     } catch (error) {
//       console.error('Error creating text message:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Create Text Message</h1>
//       <div className='space-y-4'>
//         <div>
//           <label className='block mb-2 font-semibold'>Restaurant</label>
//           <select
//             className='w-full p-3 border rounded'
//             value={restaurantId}
//             onChange={(e) => setRestaurantId(e.target.value)}
//           >
//             <option value=''>Select Restaurant</option>
//             {restaurants.map((restaurant) => (
//               <option key={restaurant._id} value={restaurant._id}>
//                 {restaurant.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label className='block mb-2 font-semibold'>Content</label>
//           <textarea
//             className='w-full p-3 border rounded'
//             value={content}
//             onChange={(e) => setContent(e.target.value)}
//             placeholder='Enter message content'
//           />
//         </div>
//         <div>
//           <label className='block mb-2 font-semibold'>Scheduled Date</label>
//           <input
//             type='datetime-local'
//             className='w-full p-3 border rounded'
//             value={scheduledDate}
//             onChange={(e) => setScheduledDate(e.target.value)}
//           />
//         </div>
//         <button
//           onClick={handleCreate}
//           className='inline-block bg-blue-500 text-white py-2 px-4 rounded'
//           disabled={loading}
//         >
//           <FaSave className='mr-2 inline' /> {loading ? 'Saving...' : 'Save'}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AdminCreateTextMessage;
